import Modal from 'components/modals/Modal';
import PremiumCoachSide from './PremiumCoachSide';
import PremiumPlayerSide from './PremiumPlayerSide';
import { SubscriptionModalProps } from './types';

const SubscriptionModal: React.FC<SubscriptionModalProps> = ({
  isOpen,
  handleClose,
  isOwner,
  setSteps,
  steps,
  subscriptionPrice,
  coachId,
  coachName,
  playerSubscribedUntil,
  onSubscriptionSuccess,
  currency,
}) => {
  return (
    <Modal isOpen={isOpen} handleClose={handleClose}>
      {isOwner ? (
        <PremiumCoachSide />
      ) : (
        <PremiumPlayerSide
          coachName={coachName}
          coachId={coachId}
          amount={subscriptionPrice}
          playerSubscribedUntil={playerSubscribedUntil}
          setSteps={setSteps}
          steps={steps}
          onSubscriptionSuccess={onSubscriptionSuccess}
          currency={currency}
        />
      )}
    </Modal>
  );
};

export default SubscriptionModal;
